// معرفی کالا و خدمات
import React, { useState } from 'react';
import { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import CrudView from './CrudView';
import { Field, TextInput, Lookup, Modal, DataTable, basicApi, btnDisabled } from './basicShared';

const BASE_COLS = [
  { key: 'group', label: 'گروه کالا' }, { key: 'code', label: 'کد', ltr: true }, { key: 'virtual_code', label: 'کد مجازی' },
  { key: 'title', label: 'عنوان' }, { key: 'order_point', label: 'نقطه سفارش', num: true },
  { key: 'first_date', label: 'تاریخ انبارگردانی' }, { key: 'life_time', label: 'عمر مفید', num: true },
  { key: 'confirmer', label: 'تاییدکننده' }, { key: 'confirm_time', label: 'زمان تایید' },
];
const CALC_COLS = [
  { key: 'group', label: 'گروه کالا' }, { key: 'code', label: 'کد', ltr: true }, { key: 'virtual_code', label: 'کد مجازی' },
  { key: 'title', label: 'عنوان' }, { key: 'order_point', label: 'نقطه سفارش', num: true },
  { key: 'life_time', label: 'عمر مفید', num: true }, { key: 'first_date', label: 'تاریخ انبارگردانی' },
  { key: 'q1', label: 'تعداد انبارگردانی', num: true }, { key: 'confirmer', label: 'تاییدکننده' },
  { key: 'confirm_time', label: 'زمان تایید' }, { key: 'q21', label: 'قبض انبار شده', num: true },
  { key: 'q2', label: 'ورود به انبار', num: true }, { key: 'q31', label: 'واگذار شده', num: true },
  { key: 'q32', label: 'مرجوع شده', num: true }, { key: 'q3', label: 'خروج از انبار', num: true },
  { key: 'stock', label: 'موجودی', num: true }, { key: 'stockinstore', label: 'موجودی انبار', num: true },
];
// کلیک راست روی ستون‌های گردش ← ریز
const DRILL = { q21: 'slip', q2: 'in', q31: 'given', q32: 'returned', q3: 'out', stockinstore: 'store' };
const HIST_COLS = [
  { key: 'label_no', label: 'برچسب' }, { key: 'slip', label: 'قبض انبار/مجوز واگذاری' }, { key: 'date', label: 'تاریخ' },
  { key: 'price', label: 'قیمت', num: true }, { key: 'ag_kind', label: 'نوع انبارگردانی' },
  { key: 'ag_qty', label: 'تعداد انبارگردانی', num: true }, { key: 'buy_qty', label: 'تعداد خرید', num: true },
  { key: 'given_qty', label: 'تعداد واگذارشده', num: true }, { key: 'return_qty', label: 'تعداد مرجوعی', num: true },
  { key: 'stock', label: 'موجودی', num: true }, { key: 'receiver', label: 'دریافت کننده' }, { key: 'leave_date', label: 'تاریخ خروج' },
  { key: 'send_letter_no', label: 'شماره نامه ارسال به خزانه' }, { key: 'send_letter_date', label: 'تاریخ نامه ارسال به خزانه' },
  { key: 'request_no', label: 'شماره درخواست' }, { key: 'request_date', label: 'تاریخ درخواست' },
  { key: 'asker', label: 'درخواست کننده' }, { key: 'asker_dept', label: 'واحد درخواست کننده' }, { key: 'seller', label: 'فروشنده' },
  { key: 'factor_no', label: 'شماره فاکتور' }, { key: 'factor_date', label: 'تاریخ فاکتور' },
  { key: 'hazineh_no', label: 'شماره سند هزینه' }, { key: 'hazineh_date', label: 'تاریخ سند هزینه' },
];

function Fields({ f, set, setMany }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="کد کالا و خدمات" width="170px"><TextInput value={f.code} onChange={v => set('code', v)} ltr autoFocus /></Field>
        <Field label="کد مجازی" width="110px"><TextInput value={f.virtual_code} onChange={v => set('virtual_code', v)} ltr /></Field>
        <Field label="عنوان"><TextInput value={f.title} onChange={v => set('title', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Lookup label="گروه کالا و خدمات" text={f.group} endpoint="/goods/lookup/group/"
          onPick={r => setMany({ group_id: r.id, group: r.title || '' })} />
        <Field label="نقطه سفارش" width="110px"><TextInput value={f.order_point} onChange={v => set('order_point', v)} ltr /></Field>
        <Field label="عمر مفید(سال)" width="110px"><TextInput value={f.life_time} onChange={v => set('life_time', v)} ltr /></Field>
      </div>
    </>
  );
}

function GridDialog({ title, cols, rows, onClose }) {
  return (
    <Modal title={title} onClose={onClose} width={1000} z={1300}
      footer={<><ExcelButton title={title} columns={cols} rows={rows} /><button onClick={onClose} style={ui.btnCancel}>بستن</button></>}>
      <div style={{ maxHeight: '60vh', overflow: 'auto' }}><DataTable cols={cols} rows={rows} /></div>
    </Modal>
  );
}

const EMPTY = { code: '', virtual_code: '0', title: '', group_id: 0, group: '', order_point: '0', life_time: '' };

export default function Goods({ user, onBack }) {
  const [calc, setCalc] = useState(false);
  const [dlg, setDlg] = useState(null);       // {title, cols, rows}

  const history = async (sel, setMsg) => {
    const j = await basicApi(`/goods/${sel.id}/history/`);
    if (!j.ok) { setMsg([j.msg || 'خطا']); return; }
    setDlg({ title: `سابقه — ${sel.title}`, cols: HIST_COLS, rows: j.data.map((r, i) => ({ ...r, id: i })) });
  };
  const drill = async (r, key, { setMsg }) => {
    const col = DRILL[key];
    if (!col) return;
    const need = key === 'stockinstore' ? (r.q2 > 0 || r.q3 > 0) : r[key] > 0;
    if (!need) return;
    const j = await basicApi(`/goods/${r.id}/detail/?col=${col}&from=${encodeURIComponent(r.first_date || '')}`);
    if (!j.ok) { setMsg([j.msg || 'خطا']); return; }
    const cols = j.columns.map((c, i) => ({ key: `c${i}`, label: c, num: c.startsWith('تعداد') }));
    const rows = j.data.map((row, n) => Object.fromEntries([['id', n], ...row.map((v, i) => [`c${i}`, v])]));
    setDlg({ title: r.title, cols, rows });
  };

  return (
    <CrudView user={user} onBack={onBack} form="FRMGOODS" title="کالا و خدمات" unit="کالا" buttons={['BTNHISTORY']}
      path="/goods" cols={calc ? CALC_COLS : BASE_COLS} empty={EMPTY} modalWidth={680} renderFields={Fields}
      toForm={r => ({ ...EMPTY, ...r, order_point: String(r.order_point ?? 0), life_time: String(r.life_time ?? '') })}
      listQuery={() => (calc ? '&calc=1' : '')} reloadKey={calc ? 1 : 0} changeBtn="BTNCHANGEID"
      onCellContext={calc ? drill : undefined}
      filters={() => (
        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', alignSelf: 'center' }}>
          <input type="checkbox" checked={calc} onChange={e => setCalc(e.target.checked)} />محاسبه موجودی
        </label>
      )}
      extraButtons={({ sel, fb, setMsg }) => fb.can('BTNHISTORY') && (
        <button onClick={() => sel && history(sel, setMsg)} disabled={!sel} style={btnDisabled(ui.btnItems, !!sel)}>سابقه</button>
      )}>
      {() => dlg && <GridDialog {...dlg} onClose={() => setDlg(null)} />}
    </CrudView>
  );
}
